import Vue from 'vue'
import { restErrorToString } from '@/utils'

Vue.prototype.runService = async function (vm, group, fn, ...args) {
  vm.isSubmitting = true
  try {
    return (await fn(...args)) || true
  } catch (error) {
    vm.addNotification(true, {
      group,
      type: 'error',
      text: restErrorToString(error) || 'Ukjent feil'
    })
  } finally {
    vm.isSubmitting = false
  }
  return false
}
